export const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

export const FormControlLabelStyle = ({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 5px',
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: 9
    }
  }
});

export const GridStyle = {
  rowGap: '24px'
};

export const RadioGroupStyle = () => ({
  width: 'fit-content',
  gap: '24px'
});

export const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

export const SummaryFormWrapper = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
});

export const PrintedBoxStyle = () => ({
  '@media print': {
    paddingTop: '12px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
});

export const TextStyle = ({ theme }) => ({
  ...theme.typography.sm,
  cursor: 'pointer',
  color: theme.palette.text.blue,
  textDecoration: 'underline',
  textDecorationColor: theme.palette.text.blue
});
